<template>
    <v-card class="main-card">
        <v-card-title class="primary title white--text">
            Time Series Plots
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 fill-height>
                    <div class="leftside">
                        <points-draggable></points-draggable>
                    </div>
                    <div class="rightside">
                        <div class="pa-2">
                        <v-layout row wrap>
                            <v-flex xs12 md6>
                                <date-range-selector v-model="range"></date-range-selector>
                            </v-flex>
                            <v-flex xs12 md6>
                                <v-switch
                                        v-model="onOnly"
                                        label="View Points when Chiller is On"
                                ></v-switch>
                            </v-flex>
                        </v-layout>
                        </div>
                    <plot-and-selector
                            :on-only="onOnly"
                            :date-range="range"
                            v-for="(i,j) in plotCounts"
                            v-if="i"
                            :key="j"
                    ></plot-and-selector>
                        <v-btn class="accent" @click="addPlot" block large>
                            <v-icon>
                                fa-plus
                            </v-icon>
                            Add Plots
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
  import PointsDraggable from '../components/multiplots/PointsDraggable'
  import PlotAndSelector from '../components/multiplots/PlotAndSelector'
  import DateRangeSelector from '../components/DateRangeSelector'
  import moment from 'moment'
  export default {
    name: 'MultiPlots',
    components: { DateRangeSelector, PlotAndSelector, PointsDraggable },
    data () {
      return {
        range: null,
        onOnly: true,
        plotCounts: [true]
      }
    },
    methods: {
      addPlot () {
        this.plotCounts.push(true)
      }
    },
    computed: {
      totalPoints () {
        let output = 0
        for (let i in this.$store.state.pointsListStore.pointsList.sensors){
          output += this.$store.state.pointsListStore.pointsList.sensors[i].length
        }
        return output
      }
    },
      beforeMount() {
          let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
          if(maxDate){
              this.range={start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),end:moment(maxDate).format('YYYY-MM-DD')}
          }
      }
  }
</script>

<style scoped>
    .leftside {
        width: 20%;
        height: 80vh;
        float: left;
        overflow-y: scroll;
    }
    .rightside {
        width: 80%;
        float: right;
        height: 80vh;
        overflow-y: scroll;
    }
    .main-card {
        width: 100%;
    }
</style>
